import { Competence } from "./competence.model";

export class Groupe {
  groupeId: number;
  competences: Competence[];
}
